import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { AdditionalCharge } from "../models"
import { UnsafeAction } from "./UnsafeAction"

export interface AdditionalChargesToSave {
	additionalChargeCollectionUrl: string
	additionalCharges: AdditionalCharge[],
}

/* tslint:disable */
@Injectable()
export class AdditionalChargeActions {

	static LOAD_ADDITIONALCHARGE_COLLECTION = '[AdditionalCharge] Load AdditionalCharge';
	loadCollection(url: string): UnsafeAction {
		return {
			type: AdditionalChargeActions.LOAD_ADDITIONALCHARGE_COLLECTION,
			payload: url
		};
	}

	static LOAD_ADDITIONALCHARGE_COLLECTION_SUCCESS = '[AdditionalCharge] Load Collection Success';
	loadCollectionSuccess(additionalCharges: AdditionalCharge[]): UnsafeAction {
		return {
			type: AdditionalChargeActions.LOAD_ADDITIONALCHARGE_COLLECTION_SUCCESS,
			payload: additionalCharges
		};
	}

	static SAVE_ADDITIONALCHARGES = "[AdditionalCharge] save";
	public saveAdditionalCharges(additionalChargesToSave: AdditionalChargesToSave): UnsafeAction{
		return {
			type: AdditionalChargeActions.SAVE_ADDITIONALCHARGES,
			payload: additionalChargesToSave
		}
	}

	static DELETE_ADDITIONALCHARGE = "[AdditionalCharge] delete AdditionalCharge"
	deleteAdditionalCharge(deleteRef: string): UnsafeAction{
		return {
			type: AdditionalChargeActions.DELETE_ADDITIONALCHARGE,
			payload: deleteRef
		}
	}

	static ADDITIONALCHARGE_ERROR = "[AdditionalCharge] error"
	error(error: Response): UnsafeAction {
		return {
			type: AdditionalChargeActions.ADDITIONALCHARGE_ERROR,
			payload: error
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/actions/additional-charge.actions.ts